import axios, {AxiosResponse} from 'axios'
import { ID, Response } from '../../../../../_metronic/helpers'
import { SERVER_URL } from '../../../../ServerConfig'
import {Role, RolesQueryResponse} from './_models'

const API_URL = SERVER_URL
const GET_ROLES_URL = `${API_URL}/role`

const getRoles = (query: string): Promise<RolesQueryResponse> => {
  return axios
    .get(`${GET_ROLES_URL}?${query}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
    })
    .then((d: AxiosResponse<RolesQueryResponse>) => d.data)
}

const getRoleById = (id: ID): Promise<Role | undefined> => {
  return axios
    .get(`${GET_ROLES_URL}/${id}`)
    .then((response: AxiosResponse<Response<Role>>) => response.data)
    .then((response: Response<Role>) => response.data)
}

const createRole = (role: Role): Promise<Role | undefined> => {
  return axios
    .post(GET_ROLES_URL, role)
    .then((response: AxiosResponse<Response<Role>>) => response.data)
    .then((response: Response<Role>) => response.data)
}

const updateRole = (role: Role): Promise<Role | undefined> => {
  return axios
    .put(`${GET_ROLES_URL}/${role.id}`, role)
    .then((response: AxiosResponse<Response<Role>>) => response.data)
    .then((response: Response<Role>) => response.data)
}

const deleteRole = (id: ID): Promise<void> => {
  return axios.delete(`${GET_ROLES_URL}/${id}`).then(() => {})
}

// export const getRolesList = async () => {
//   try {
//     const response = await axios.get(`${API_URL}/role?status=1`)
//     if (response.data.responseStatus === 200) {
//       return response.data.data.map((role: any) => ({
//         value: role.id,
//         label: role.name
//       }))
//     }
//     return []
//   } catch (error) {
//     console.error('Error fetching roles:', error)
//     return []
//   }
// }
export const getRolesList = async (unpaginated :Boolean) => {
  try {
    const queryParams = unpaginated ? '?status=1&limit=-1' : '?status=1'
    const response = await axios.get(`${API_URL}/role${queryParams}`)
    
    if (response.data.responseStatus === 200) {
      return response.data.data.map((role: any) => ({
        value: role.id,
        label: role.name
      }))
    }
    return []
  } catch (error) {
    console.error('Error fetching roles:', error)
    return []
  }
}

export {
  getRoles,
  deleteRole,
  getRoleById,
  createRole,
  updateRole
} 